import React from 'react';
import PropTypes from 'prop-types';
import { logError } from '@app/error';

class ErrorBoundary extends React.Component {
  componentDidCatch(error) {
    logError(error);
  }

  render() {
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
